import { render, staticRenderFns } from "./orderReceiptList.vue?vue&type=template&id=b17984ce"
import script from "./orderReceiptList.vue?vue&type=script&lang=js"
export * from "./orderReceiptList.vue?vue&type=script&lang=js"
import style0 from "./orderReceiptList.vue?vue&type=style&index=0&id=b17984ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports